// src/components/shared/DataTable.jsx
import React from 'react';
import './DataTable.css';

const DataTable = ({ columns, data, keyField = "id", onRowAction, rowClassName }) => {
  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item) => {
              const className = rowClassName ? rowClassName(item) : '';
              return (
                <tr
                  key={item[keyField]}
                  className={className}
                >
                  {columns.map((column) => (
                    <td key={`${item[keyField]}-${column.key}`}>
                      {column.render ? column.render(item) : item[column.key]}
                    </td>
                  ))}
                  {onRowAction && (
                    <td>
                      {onRowAction(item)}
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={columns.length + (onRowAction ? 1 : 0)}>
                Keine Daten gefunden.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;